import apiService from './api.js';

export const originationService = {
  // Leads
  async getLeads() {
    try {
      const response = await apiService.get('/origination/leads');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async createLead(leadData) {
    try {
      const response = await apiService.post('/origination/leads', leadData);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async updateLead(leadId, leadData) {
    try {
      const response = await apiService.put(`/origination/leads/${leadId}`, leadData);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async deleteLead(leadId) {
    try {
      const response = await apiService.delete(`/origination/leads/${leadId}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Pipeline
  async getPipeline() {
    try {
      const response = await apiService.get('/origination/pipeline');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async convertLead(leadId) {
    try {
      const response = await apiService.post(`/origination/leads/${leadId}/convert`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Métricas
  async getMetrics() {
    try {
      const response = await apiService.get('/origination/metrics');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  }
};